import { clsx } from 'clsx';
import React from 'react';
import CloseIcon from 'src/assets/img/close-icon';

interface InvalidMessageProps {
  className?: string;
  invalidMessage?: string | React.ReactNode;
  isPassword?: boolean;
  closeIconVisible?: boolean;
}

export const InvalidMessage = ({
  className = '',
  invalidMessage,
  isPassword,
  closeIconVisible = true,
}: InvalidMessageProps) => {
  const [showMessage, setShowMessage] = React.useState(true);
  const handleCloseMessage = () => {
    setShowMessage(false);
  };
  const isString = typeof invalidMessage === 'string';

  return (
    isString &&
    showMessage && (
      <div
        className={clsx(
          'error-message px-3.5 py-0 relative rounded-sm-5 bg-error_bg text-error font-jamjuree text-sm font-semibold',
          isPassword && 'pr-10',
          className,
        )}
      >
        {invalidMessage}
        {closeIconVisible && (
          <button onClick={handleCloseMessage} className="absolute top-0.5 right-0.5">
            <CloseIcon className="transition hover:opacity-100 opacity-40 w-3 h-3" />
          </button>
        )}
      </div>
    )
  );
};
